'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// connects to the redux store
var Login = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, app: state.moduleData };
}, authActions), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    (0, _classCallCheck3.default)(this, Login);
    return (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).apply(this, arguments));
  }

  (0, _createClass3.default)(Login, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          logout = _props.logout;

      var styles = require('./Login.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.loginPage },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Login' }),
        _react2.default.createElement(
          'div',
          { className: styles.header },
          !user && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.LoginForm, null)
          ),
          user && !this.props.app.data && _react2.default.createElement(_components.LoadingScreen, null),
          user && this.props.app.data && _react2.default.createElement(
            'div',
            { className: styles.centerScreen },
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 4, sm: 2, xs: 2, lg: 4 },
                '\xA0'
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 4, sm: 8, xs: 8, lg: 4 },
                _react2.default.createElement(
                  ReactBootstrap.Panel,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: styles.textCenter },
                    _react2.default.createElement(
                      'h1',
                      null,
                      'Logged in as ',
                      user.username
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                      ReactBootstrap.Button,
                      { onClick: logout, bsStyle: 'primary' },
                      'Logout'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 4, sm: 2, xs: 2, lg: 4 },
                '\xA0'
              )
            )
          )
        )
      );
    }
    // when you define your data models
    // there are properties they take in

  }]);
  return Login;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  app: _propTypes2.default.object,
  logout: _propTypes2.default.func
}, _temp)) || _class);
exports.default = Login;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Login.js
// module id = 1274
// module chunks = 0